import config from '../app-config';

const Footer = () => {
    return (
        <nav className="navbar navbar-expand-lg fixed-bottom navbar-south bg-white" role="navigation" id="navbarSouth">
            <div className="container" id="navbarSouthContainer">
                <div className="row no-gutters">
                    <div className="col-8 mt-3">
                        <header>
                            <h3 className="text-md-left text-center">Meld je aan voor de digitale informatiebijeenkomst!</h3>
                        </header>
                    </div>
                    <div className="nav-toolbar">
                            <a type="button" className="btn btn-secondary text-color" href={config.informatiebijeenkomstUrl}>
                                AANMELDEN
                            </a>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Footer;